import { render, staticRenderFns } from "./RuleComponents.vue?vue&type=template&id=004da60a&"
import script from "./RuleComponents.vue?vue&type=script&lang=js&"
export * from "./RuleComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports